import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";
import { withStyles } from "@material-ui/core/styles";

import { athenaGreen, statRed } from "../globals";

const styles = (theme) => ({
  typeIcon: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: 22,
    height: 22,
    fontSize: 12,
    borderRadius: "50%",
    fontWeight: "bold",
  },
  validated: {
    backgroundColor: athenaGreen,
    color: "white",
  },
  validatedSubIcon: {
    width: 15,
    height: 22,
  },
  base: {
    backgroundColor: theme.palette.primary.main,
    color: "white",
  },
  baseOptimization: {
    backgroundColor: theme.palette.primary.dark,
    color: "white",
  },
  greyCircularIcon: {
    border: "2px solid #b1b1b1",
    color: "#b1b1b1",
  },
  simulationReducedScope: {
    border: `1px solid ${theme.palette.primary.dark}`,
    color: theme.palette.primary.dark,
  },
});

export function CycleIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 46 46">
      <g
        fill="none"
        fillRule="evenodd"
        stroke="#FFF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      >
        <path d="M30.237 11.316a3.29 3.29 0 1 1 0 6.578 3.29 3.29 0 0 1 0-6.578zM32.563 16.931l2.279 2.28M23.79 17.632H12.736a1.58 1.58 0 0 1-1.58-1.58v-1.578a1.58 1.58 0 0 1 1.58-1.58h11.052M13.132 21.579a.395.395 0 1 1 0 .79.395.395 0 0 1 0-.79M16.684 22.368h12.632M13.132 27.105a.395.395 0 1 1 0 .79.395.395 0 0 1 0-.79M16.684 27.895h12.632M13.132 32.632a.395.395 0 1 1 0 .79.395.395 0 0 1 0-.79M16.684 33.421h12.632" />
      </g>
    </SvgIcon>
  );
}
export function ArrowIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 7 12">
      <path
        fill="#FFF"
        fillRule="evenodd"
        d="M5.293.707L1.414 4.586a2 2 0 0 0 0 2.828l3.879 3.879A1 1 0 0 0 7 10.586V1.414A1 1 0 0 0 5.293.707z"
      />
    </SvgIcon>
  );
}

export function DashboardIcon(props) {
  const stroke = props.stroke ? props.stroke : "#FFF";
  return (
    <SvgIcon {...props} viewBox="6 0 46 46">
      <g
        fill="none"
        fillRule="evenodd"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.533"
      >
        <path d="M22.042 23.59a.75.75 0 0 1-.748.752h-5.98a.749.749 0 0 1-.747-.75V15.317a.75.75 0 0 1 .748-.751l5.98.01a.75.75 0 0 1 .747.751v8.262zM31.814 19.004a.743.743 0 0 1-.748.738h-5.98a.742.742 0 0 1-.747-.737v-3.69a.742.742 0 0 1 .746-.738l5.98-.01a.744.744 0 0 1 .749.737v3.7zM22.042 31.077a.745.745 0 0 1-.75.74l-5.98-.01a.743.743 0 0 1-.745-.74v-3.686a.743.743 0 0 1 .746-.74H21.294a.744.744 0 0 1 .748.74v3.696zM25.087 31.817a.75.75 0 0 1-.748-.752v-8.271a.75.75 0 0 1 .747-.752h5.98a.75.75 0 0 1 .748.752v8.26a.75.75 0 0 1-.747.753l-5.98.01z" />
      </g>
    </SvgIcon>
  );
}

export const CycleWorkflowIcon = (props) => {
  const stroke = props.stroke ? props.stroke : "#FFF";
  return (
    <SvgIcon {...props} viewBox="0 0 46 46">
      <g
        fill="none"
        fillRule="evenodd"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      >
        <path
          d="M19.237.316a3.29 3.29 0 110 6.578 3.29 3.29 0 010-6.578zM21.563 5.931L23.842 8.211M12.79 6.632H1.736a1.58 1.58 0 01-1.58-1.58V3.475a1.58 1.58 0 011.58-1.58h11.052M2.132 10.579a.395.395 0 110 .79.395.395 0 010-.79M5.684 11.368L18.316 11.368M2.132 16.105a.395.395 0 110 .79.395.395 0 010-.79M5.684 16.895L18.316 16.895M2.132 21.632a.395.395 0 110 .79.395.395 0 010-.79M5.684 22.421L18.316 22.421"
          transform="translate(11 11)"
        />
      </g>
    </SvgIcon>
  );
};

export function DataIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 46 46">
      <g
        fill="none"
        fillRule="evenodd"
        stroke="#FFF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        opacity=".6"
      >
        <path d="M28.526 22.21a6.315 6.315 0 1 1 0 12.632 6.315 6.315 0 1 1 0-12.631zM28.526 25.368v6.316M28.526 31.684l-2.368-2.368M28.526 31.684l2.369-2.368M14.316 17.474h11.052M14.316 22.211h6.316M14.316 26.947h3.947" />
        <path d="M18.263 31.684h-5.526a1.58 1.58 0 0 1-1.58-1.579V12.737a1.58 1.58 0 0 1 1.58-1.58h11.188c.42 0 .82.167 1.116.463l3.023 3.023c.296.296.462.697.462 1.116v2.504" />
      </g>
    </SvgIcon>
  );
}

export function DemandIcon(props) {
  const stroke = props.stroke ? props.stroke : "#FFF";
  const scale = props.transform ? props.transform : "scale(1)";
  const viewBox = props.viewBox ? props.viewBox : "5 5 45 45";
  const strokeWidth = props.strokeWidth ? props.strokeWidth : "1.5";
  return (
    <SvgIcon {...props} stroke={stroke} viewBox={viewBox}>
      <g
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
        transform={scale}
      >
        <path d="M11.363 23.181L21.847 12.69a1.667 1.667 0 0 1 2.356.008h.001l10.493 10.484" />
        <path d="M31.363 19.851v13.33H14.697V19.846" />
        <path d="M26.363 33.181v-5a3.333 3.333 0 1 0-6.666 0v5M23.03 17.348a2.083 2.083 0 1 1 .001 4.165 2.083 2.083 0 0 1-.001-4.165z" />
      </g>
    </SvgIcon>
  );
}

export function DotIcon(props) {
  const fill = props.fill ? props.fill : "#FFF";
  return (
    <SvgIcon {...props} viewBox="0 0 6 6">
      <circle
        cx="338"
        cy="185"
        r="1"
        fill={fill}
        fillRule="evenodd"
        transform="translate(-335 -182)"
      />
    </SvgIcon>
  );
}

export function SupplyIcon(props) {
  const stroke = props.stroke ? props.stroke : "#FFF";
  const scale = props.transform ? props.transform : "scale(1)";
  const viewBox = props.viewBox ? props.viewBox : "4 5 45 45";
  const strokeWidth = props.strokeWidth ? props.strokeWidth : "1.5";
  return (
    <SvgIcon {...props} stroke={stroke} viewBox={viewBox}>
      <g
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
        transform={scale}
      >
        <path d="M26.333 24.579l5.461-2.586c.413-.195.913-.037 1.118.353.058.11.088.23.088.353v10.564c0 .872-.747 1.58-1.667 1.58H13c-.92 0-1.667-.708-1.667-1.58V24.58l2.36-10.428a.823.823 0 0 1 .814-.625h1.986c.394 0 .733.26.815.625l2.359 10.428 5.46-2.586c.413-.195.913-.037 1.119.353.057.11.087.23.087.353v1.88M19.667 28.526H23M19.667 31.684H23M26.333 28.526h3.334M26.333 31.684h3.334M19.672 11.283a8.089 8.089 0 0 1 3.328.655c8.254 3.338 11.667-.78 11.667-.78" />
      </g>
    </SvgIcon>
  );
}

export function FileIcon(props) {
  const stroke = props.stroke ? props.stroke : "#FFF";
  const strokeWidth = props.strokeWidth ? props.strokeWidth : "1.5";
  return (
    <SvgIcon {...props} viewBox="4 0 46 46">
      <g
        fill="none"
        fillRule="evenodd"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
      >
        <path d="M28.526 22.21a6.315 6.315 0 1 1 0 12.632 6.315 6.315 0 1 1 0-12.631zM28.526 25.368v6.316M28.526 31.684l-2.368-2.368M28.526 31.684l2.369-2.368M14.316 17.474h11.052M14.316 22.211h6.316M14.316 26.947h3.947" />
        <path d="M18.263 31.684h-5.526a1.58 1.58 0 0 1-1.58-1.579V12.737a1.58 1.58 0 0 1 1.58-1.58h11.188c.42 0 .82.167 1.116.463l3.023 3.023c.296.296.462.697.462 1.116v2.504" />
      </g>
    </SvgIcon>
  );
}

export function RawIcon(props) {
  const stroke = props.stroke ? props.stroke : "#FFF";
  const strokeWidth = props.strokeWidth ? props.strokeWidth : "1.5";
  return (
    <SvgIcon {...props} viewBox="4 0 46 46">
      <g
        fill="none"
        fillRule="evenodd"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
      >
        <path d="M25.368 19.053v-4.737h-6.315v4.737a6.928 6.928 0 0 0-4.737 6.571v7.64a1.58 1.58 0 0 0 1.579 1.578h12.631a1.58 1.58 0 0 0 1.58-1.579v-7.639a6.928 6.928 0 0 0-4.738-6.571zM26.947 12.737a1.58 1.58 0 0 1-1.579 1.579h-6.315a1.58 1.58 0 0 1 0-3.158h6.315a1.58 1.58 0 0 1 1.58 1.579z" />
        <path d="M19.842 23.79h4.737a.79.79 0 0 1 .79.789v3.158a.79.79 0 0 1-.79.79h-4.737a.79.79 0 0 1-.79-.79v-3.158a.79.79 0 0 1 .79-.79z" />
      </g>
    </SvgIcon>
  );
}

export function ScenarioIcon(props) {
  const stroke = props.stroke ? props.stroke : "#FFF";
  const strokeWidth = props.strokeWidth ? props.strokeWidth : "1.5";
  return (
    <SvgIcon {...props} viewBox="5 0 46 46">
      <g
        fill="none"
        fillRule="evenodd"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
      >
        <path d="M21.47 12.934a2.06 2.06 0 0 0 3.06 0l.99-1.096a2.062 2.062 0 0 1 3.59 1.487l-.075 1.474a2.063 2.063 0 0 0 2.165 2.165l1.474-.075a2.062 2.062 0 0 1 1.484 3.59l-1.097.99a2.062 2.062 0 0 0 0 3.062l1.097.989a2.062 2.062 0 0 1-1.487 3.59l-1.474-.075a2.063 2.063 0 0 0-2.165 2.164l.075 1.474a2.062 2.062 0 0 1-3.587 1.485l-.99-1.096a2.062 2.062 0 0 0-3.06 0l-.99 1.096a2.062 2.062 0 0 1-3.585-1.483l.076-1.474a2.061 2.061 0 0 0-2.171-2.166l-1.474.076a2.061 2.061 0 0 1-1.484-3.591l1.097-.99a2.062 2.062 0 0 0 0-3.06l-1.097-.991a2.062 2.062 0 0 1 1.483-3.584l1.474.074a2.061 2.061 0 0 0 2.166-2.169l-.07-1.475a2.062 2.062 0 0 1 3.585-1.483l.99 1.092zM17.474 26.947h11.842" />
        <path d="M18.263 19.053h3.158v7.894h-3.158zM24.579 22.21h3.158v4.737h-3.158z" />
      </g>
    </SvgIcon>
  );
}

export function InfoIcon(props) {
  const stroke = props.stroke ? props.stroke : "#CCC";
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="19"
      viewBox="0 0 19 19"
    >
      <g
        fill="none"
        fillRule="evenodd"
        stroke={stroke}
        strokeWidth="2"
        transform="translate(1 1)"
      >
        <circle cx="8.5" cy="8.5" r="8.5" />
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M10.045 12.17h-.58c-.639 0-1.158-.519-1.158-1.159V8.114a.58.58 0 0 0-.58-.58h-.58M8.307 4.926a.29.29 0 0 0-.29-.29M8.017 4.636a.29.29 0 1 0 .29.29"
        />
      </g>
    </svg>
  );
}

export const BaseScenarioIcon = withStyles(styles)((props) => {
  const { classes } = props;
  return <div className={[classes.typeIcon, classes.base].join(" ")}>BR</div>;
});

export const ValidatedScenarioIcon = withStyles(styles)((props) => {
  const { classes } = props;
  return (
    <div className={[classes.typeIcon, classes.validated].join(" ")}>
      <VerifiedUserIcon className={classes.validatedSubIcon} />
    </div>
  );
});

export const BaseOptimizationIcon = withStyles(styles)((props) => {
  const { classes } = props;
  return (
    <div className={[classes.typeIcon, classes.baseOptimization].join(" ")}>
      BO
    </div>
  );
});

export const SimulationIcon = withStyles(styles)((props) => {
  const { classes } = props;
  return (
    <div className={[classes.typeIcon, classes.greyCircularIcon].join(" ")}>
      S
    </div>
  );
});

export const SimulationReducedScopeIcon = withStyles(styles)((props) => {
  const { classes } = props;
  return (
    <div
      className={[classes.typeIcon, classes.simulationReducedScope].join(" ")}
    >
      SR
    </div>
  );
});

export const DraftScenarioIcon = withStyles(styles)((props) => {
  const { classes } = props;
  return (
    <div className={[classes.typeIcon, classes.greyCircularIcon].join(" ")}>
      D
    </div>
  );
});

export const UnconstainedScenarioIcon = withStyles(styles)((props) => {
  const { classes } = props;
  return (
    <div className={[classes.typeIcon, classes.greyCircularIcon].join(" ")}>
      UC
    </div>
  );
});

export function DownloadIcon(props) {
  const { disabled, size, strokeWidth } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size ? size : "32"}
      height={size ? size : "32"}
      viewBox="0 0 32 32"
    >
      <g
        fill="none"
        fillRule="evenodd"
        stroke={disabled ? "#a8a7a7" : "#00A8D7"}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth ? strokeWidth : "2"}
      >
        <path d="M15.95 1.502c7.98 0 14.448 6.468 14.448 14.448S23.93 30.398 15.95 30.398 1.502 23.93 1.502 15.95 7.97 1.502 15.95 1.502zM15.95 8.726v14.448M15.95 23.174l-5.418-5.418M15.95 23.174l5.418-5.418" />
      </g>
    </svg>
  );
}

export function ChangeIcon(props) {
  const fill = props.fill ? props.fill : "#919191";
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <defs>
        <path id="a" d="M0 0h24v24H0z" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="b" fill="#fff">
          <use href="#a" />
        </mask>
        <path
          fill={fill}
          fillRule="nonzero"
          d="M9.01 14H2v2h7.01v3L13 15l-3.99-4v3zm5.98-1v-3H22V8h-7.01V5L11 9l3.99 4z"
          mask="url(#b)"
        />
      </g>
    </svg>
  );
}

export function PersonIcon(props) {
  const fill = props.fill ? props.fill : "#B1B1B1";
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
    >
      <path
        fill={fill}
        fillRule="nonzero"
        d="M14.5 11c1.38 0 2.49-1.12 2.49-2.5S15.88 6 14.5 6a2.5 2.5 0 0 0 0 5zM7 10c1.66 0 2.99-1.34 2.99-3S8.66 4 7 4C5.34 4 4 5.34 4 7s1.34 3 3 3zm7.5 3c-1.83 0-5.5.92-5.5 2.75V18h11v-2.25c0-1.83-3.67-2.75-5.5-2.75zM7 12c-2.33 0-7 1.17-7 3.5V18h7v-2.25c0-.85.33-2.34 2.37-3.47C8.5 12.1 7.66 12 7 12z"
      />
    </svg>
  );
}

export function MachineIcon(props) {
  const fill = props.fill ? props.fill : "#B1B1B1";
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
    >
      <path
        fill={fill}
        fillRule="nonzero"
        d="M14 8H8v6h6V8zm-2 4h-2v-2h2v2zm8-2V8h-2V6c0-1.1-.9-2-2-2h-2V2h-2v2h-2V2H8v2H6c-1.1 0-2 .9-2 2v2H2v2h2v2H2v2h2v2c0 1.1.9 2 2 2h2v2h2v-2h2v2h2v-2h2c1.1 0 2-.9 2-2v-2h2v-2h-2v-2h2zm-4 6H6V6h10v10z"
      />
    </svg>
  );
}

export function Step1Icon(props) {
  // basic
  const stroke1 = props.stroke ? props.stroke : "#00A8D7";
  const stroke2 = props.stroke ? props.stroke : "#0069B3";
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      >
        <path
          stroke={stroke1}
          d="M5.25 7.477h6M5.25 11.977h7.5M5.25 16.477h13.5"
        />
        <path
          stroke={stroke2}
          d="M2.25 3.023a1.5 1.5 0 0 0-1.5 1.5v14.954a1.5 1.5 0 0 0 1.5 1.5h19.5a1.5 1.5 0 0 0 1.5-1.5v-12a1.5 1.5 0 0 0-.426-1.047l-2.883-2.955a1.502 1.502 0 0 0-1.074-.452H2.25z"
        />
      </g>
    </svg>
  );
}

export function Step2Icon(props) {
  // layer
  const stroke1 = props.stroke ? props.stroke : "#00A8D7";
  const stroke2 = props.stroke ? props.stroke : "#0069B3";
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      >
        <path
          stroke={stroke1}
          d="M22.91 6.953L12.7 1.672a1.545 1.545 0 0 0-1.416 0L1.076 6.953a.615.615 0 0 0 0 1.094l10.209 5.281c.444.229.972.229 1.416 0L22.91 8.047a.616.616 0 0 0 0-1.094z"
        />
        <path
          stroke={stroke2}
          d="M.758 12.75l10.527 5.078c.444.229.972.229 1.416 0l10.557-5.078"
        />
        <path
          stroke={stroke2}
          d="M.758 17.25l10.527 5.078c.444.229.972.229 1.416 0l10.557-5.078"
        />
      </g>
    </svg>
  );
}

export function Step3Icon(props) {
  // simu
  const stroke1 = props.stroke ? props.stroke : "#00A8D7";
  const stroke2 = props.stroke ? props.stroke : "#0069B3";
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      >
        <path stroke={stroke2} d="M12.012.75a3 3 0 1 1 0 6 3 3 0 0 1 0-6z" />
        <path
          stroke={stroke1}
          d="M12.012 3.375a.375.375 0 1 1 0 .75.375.375 0 0 1 0-.75M16.774 7.075a6.954 6.954 0 1 1-9.75.224"
        />
        <path
          stroke={stroke2}
          d="M21.045 6c3.455 4.989 2.212 11.834-2.777 15.289-4.989 3.455-11.834 2.212-15.289-2.777a10.989 10.989 0 0 1-.141-12.304"
        />
        <path stroke={stroke2} d="M20.524 8.25V6h2.25" />
      </g>
    </svg>
  );
}

export function Step3Icon2(props) {
  // layer2 not available now
  const stroke1 = props.stroke ? props.stroke : "#00A8D7";
  const stroke2 = props.stroke ? props.stroke : "#0069B3";
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      >
        <path
          stroke={stroke1}
          d="M22.91 5.953L12.7.672a1.545 1.545 0 0 0-1.416 0L1.076 5.953a.615.615 0 0 0 0 1.094l10.209 5.281c.444.229.972.229 1.416 0L22.91 7.047a.616.616 0 0 0 0-1.094z"
        />
        <path
          stroke={stroke2}
          d="M.758 11.75l10.527 5.078c.444.229.972.229 1.416 0M22.197 12.26l1.061-.51M.758 16.25l10.527 5.078c.444.229.972.229 1.416 0l1.002-.482"
        />
        <g stroke={stroke1}>
          <path d="M18.696 14.823l1.344-1.345-1.344-1.344M23.05 17.175a4.027 4.027 0 0 1-.113 1.344M22.121 14.919c.15.179.285.37.401.571M22.111 20.115a4.052 4.052 0 0 1-1.03.87" />
          <path d="M19.368 21.53a4.032 4.032 0 1 1-.336-8.05l1.008-.002" />
        </g>
      </g>
    </svg>
  );
}

export function Step4Icon(props) {
  // setting
  const stroke1 = props.stroke ? props.stroke : "#00A8D7";
  const stroke2 = props.stroke ? props.stroke : "#0069B3";
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      >
        <path
          stroke={stroke1}
          d="M17.25 15.011a1.5 1.5 0 1 1-.001 3.001 1.5 1.5 0 0 1 .001-3.001z"
        />
        <path
          stroke={stroke1}
          d="M18.524 10.708l.442 1.453c.151.5.664.798 1.174.681l1.472-.341a1.34 1.34 0 0 1 1.275 2.218l-1.031 1.111a1 1 0 0 0 0 1.362l1.031 1.108a1.338 1.338 0 0 1-1.275 2.218l-1.472-.338a.994.994 0 0 0-1.174.681l-.442 1.453a1.33 1.33 0 0 1-2.548 0l-.442-1.453a.994.994 0 0 0-1.174-.681l-1.472.341a1.338 1.338 0 0 1-1.275-2.221l1.031-1.111a1 1 0 0 0 0-1.362l-1.031-1.111a1.339 1.339 0 0 1 1.275-2.216l1.472.341a.994.994 0 0 0 1.174-.681l.442-1.453a1.329 1.329 0 0 1 2.548.001z"
        />
        <path
          stroke={stroke2}
          d="M5.25 10.511h4.5M5.25 14.261H7.5M5.25 18.011H7.5M9.75 23.261h-7.5a1.5 1.5 0 0 1-1.5-1.5V6.011a1.5 1.5 0 0 1 1.5-1.5H6a3.75 3.75 0 0 1 7.5 0h3.75a1.5 1.5 0 0 1 1.5 1.5v.75"
        />
        <path
          stroke={stroke2}
          d="M9.75 3.761a.375.375 0 1 1-.375.375c0-.207.168-.375.375-.375"
        />
      </g>
    </svg>
  );
}

export function WarningIcon(props) {
  // warning
  const stroke1 = props.stroke ? props.stroke : "#333";
  const stroke2 = props.stroke ? props.stroke : statRed;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      >
        <path
          stroke={stroke1}
          d="M12 7v6M12 16c.207 0 .375.168.375.375M11.625 16.375c0-.207.168-.375.375-.375M12 16.75a.375.375 0 0 1-.375-.375M12.375 16.375a.375.375 0 0 1-.375.375"
        />
        <path
          stroke={stroke2}
          d="M12 4a8.25 8.25 0 1 1 0 16.5A8.25 8.25 0 0 1 12 4z"
        />
        <path
          stroke={stroke2}
          d="M19.648 20.5c4.556-4.223 4.826-11.341.603-15.897-.193-.209-.394-.41-.603-.603M4.353 4C-.203 8.222-.475 15.338 3.747 19.894c.194.21.396.412.606.606"
        />
      </g>
    </svg>
  );
}
